/**
 * Javascript file for adding a kirc result to user using the kirc results hash code.
 * @author Adrian Rebmann, Yannik Sprengart, Andrea Villeda
 */

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { saveResForUser } from "../../../../api";
export default {
  name: "ResAdd",
  props: ["hash"],
  components: {
    Loading,
  },

  /**
   * The vue instance's data object.
   * @property {boolean} error - There has been an error.
   * @property {boolean} isLoading - Information is being loaded.
   * @property {boolean} fullPage - The whole page is being loaded.
   */
  data() {
    return {
      error: false,
      isLoading: false,
      fullPage: true,
    };
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    this.isLoading = true;
    this.save().then((res) => {
      this.isLoading = false;
    });
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Save the result of the AI readiness check for this user.
     */
    save() {
      return saveResForUser(this.hash)
        .then(() => {
          this.$router.push({ name: "Readinesscheck" });
        })
        .catch((err) => {
          this.error = true;
          window.setTimeout(() => {}, 1000);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/company/kirc/result/resadd.js